import { Table, Switch, Select, Tooltip, Input, Space, Button, Checkbox, Popconfirm } from 'antd';
import { useEffect, useState } from 'react';
import fetchApi from '../../../utils/api/fetchApi'
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import { columnsheadId } from '../../universal/columnshead';
import getList from '../../universal/getList';
import systematic from '../../../config/systematic';
import RoleOrUserLicenseExtend from './RoleOrUserLicenseExtend';
import antdMessage from '../../../utilsTsx/components/system/antdMessage';

const RoleOrUserLicense = (props: any) => {

    /** 使用类型 userLicense or roleLicense or wxUserLicense */
    const useType = props.useType;
    const { info, closeModal } = props;
    const { roleOrUserId, itemName } = info
    /** 后端数据bmService */
    const bmService = systematic.bmService;
    const [rows, setRows] = useState<any>();
    const [licenseTypeData, setLicenseTypeData] = useState<any>();
    const [licenseTypeIdData, setLicenseTypeIdData] = useState<any>();
    const [licenseGroupData, setLicenseGroupData] = useState<any>();
    const [licenseGroupIdData, setLicenseGroupIdData] = useState<any>();
    const [currentData, setCurrentData] = useState(1);
    const [pageSizeData, setPageSizeData] = useState(10);
    const [totalData, setTotalData] = useState(0);
    const [queryData, setQueryData] = useState('');
    const [modalExtend, setModalExtend] = useState(false);
    const [extendInfo, setExtendInfo] = useState<any>();
    const [isAllData, setIsAllData] = useState(false);

    let title: any;
    switch (useType) {
        case 'userLicense':
            title = '用户 [ ' + itemName + ' ] 权限';
            break;
        case 'roleLicense':
            title = '角色 [ ' + itemName + ' ] 权限';
            break;
        case 'webWxUserLicense':
            title = '微信用户 [ ' + itemName + ' ] 权限';
            break;
    };

    /** 数据刷新中 */
    let loading = false;

    /** 默认权根类型id */
    const defaultLicenseTypeId = 'webAuth';

    useEffect(() => {
        setLicenseTypeIdData(defaultLicenseTypeId);
        setLicenseGroupIdData(-1);
        getRoleLicense({
            licenseTypeId: defaultLicenseTypeId,
            licenseGroupId: '-1',
            current: currentData,
            pageSize: pageSizeData,
            queryString: queryData
        });

        const fetchData = async () => {
            fetchApi.GET(bmService,
                {
                    apiId: 'generalData',
                    apiVariable: 'licenseType',
                    apiExtend: 'showList'
                }).then(res => {

                    if (res.success) {
                        setLicenseTypeData(res.data);
                    }
                });
            fetchApi.GET(bmService,
                {
                    apiId: 'licenseGroup',
                    apiExtend: 'showList'
                }).then(res => {
                    if (res.success) {
                        setLicenseGroupData(res.data.concat({
                            icon: null,
                            id: -1,
                            licenseGroupName: "所有权限组",
                            licenseGroupSort: null,
                        }));
                    }
                });
        };
        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    const handleOk = (e: any) => {
        closeModal();
    };

    const licenseTypeChange = (e: any) => {
        setLicenseTypeIdData(e);
        getRoleLicense({
            licenseTypeId: e,
            licenseGroupId: licenseGroupIdData,
            current: 1,
            pageSize: pageSizeData,
            queryString: queryData
        });
    };

    const licenseGroupChange = (e: any) => {
        setLicenseGroupIdData(e);
        getRoleLicense({
            licenseTypeId: licenseTypeIdData,
            licenseGroupId: e,
            current: 1,
            pageSize: pageSizeData,
            queryString: queryData
        });
    };

    /**
    * 获取数据
    * @param options 选项
    * @returns 
    */
    const getRoleLicense = async (options?: {
        /** 权限类型id */
        licenseTypeId?: string,
        /** 权限组id */
        licenseGroupId?: string,
        /** 当前页 */
        current?: number,
        /** 分页数量 */
        pageSize?: number,
        /** 查询内容 */
        queryString?: string
    }) => {
        if (typeof options === 'undefined') {
            options = {};
        }
        let { licenseTypeId, licenseGroupId, current, pageSize, queryString } = options;
        licenseTypeId = licenseTypeId ? licenseTypeId : licenseTypeIdData;
        licenseGroupId = licenseGroupId ? licenseGroupId : licenseGroupIdData;
        current = current ? current : currentData;
        pageSize = pageSize ? pageSize : pageSizeData;
        queryString = queryString ? queryString : queryData;
        if (loading === true) { return }
        loading = true;
        fetchApi.GET(
            bmService,
            {
                apiId: useType,
                apiExtend: 'query',
                id: roleOrUserId,
                licenseTypeId,
                licenseGroupId,
                current,
                pageSize,
                queryString
            }).then(res => {
                if (res.success === true) {
                    setRows(res.data.rows);
                    setLicenseTypeIdData(licenseTypeId);
                    setLicenseGroupIdData(licenseGroupId);
                    setCurrentData(res.data.current);
                    setPageSizeData(res.data.pageSize);
                    setTotalData(res.data.total);
                    setQueryData(res.data.queryString)
                }
                loading = false;
            })
    };

    //改变数据
    const handleChange = async (id: number, columnName: string, isValue: boolean) => {
        const bodys = {
            apiId: useType,
            apiVariable: id,
            apiExtend: 'updateOne',
            apiData: {
                columnName,
                value: isValue
            }
        }
        fetchApi.PUT(bmService, bodys).then(res => {
            if (res.success === true) {
                antdMessage('success', '编辑成功');
                getRoleLicense({
                    licenseTypeId: licenseTypeIdData,
                    licenseGroupId: licenseGroupIdData,
                    current: currentData,
                    pageSize: pageSizeData,
                    queryString: queryData
                });
            }
            else {
                antdMessage('error', '编辑失败', { description: res.message });
            }
        }).catch(err => {
            antdMessage('error', '删编辑失败', { description: err.message });
        })
    };

    // 表格分页属性
    const paginationProps = {
        showSizeChanger: true,
        showQuickJumper: false,
        showTotal: () => `共${totalData}条`,
        pageSize: pageSizeData,
        current: currentData,
        total: totalData,
        onShowSizeChange: (current: number, pageSize: number) =>
            getRoleLicense({
                licenseTypeId: licenseTypeIdData,
                licenseGroupId: licenseGroupIdData,
                current,
                pageSize,
                queryString: queryData
            }),
        onChange: (current: number) =>
            getRoleLicense({
                licenseTypeId: licenseTypeIdData,
                licenseGroupId: licenseGroupIdData,
                current,
                pageSize: pageSizeData,
                queryString: queryData
            }),
    };

    /** 关闭extend */
    const onCloseModalExtend = () => {
        setModalExtend(false);
    };
    /** 打开extend */
    const openExtend = (record: any) => {
        setExtendInfo({
            id: record.id,
            licenseName: record.license.licenseName
        })
        setModalExtend(true);
    };

    /** 更新数据 */
    const handleUpdate = () => {
        fetchApi.PUT(bmService,
            {
                apiId: useType,
                apiExtend: 'updateData',
                apiData: {
                    id: roleOrUserId,
                    licenseTypeId: licenseTypeIdData
                }
            }).then(res => {
                if (res.success) {
                    getRoleLicense();
                    antdMessage('success', '更新数据成功');
                }
            });
    };

    /** 清除所有空数据 */
    const handleClearEmptyData = () => {
        fetchApi.DELETE(bmService,
            {
                apiId: useType,
                apiExtend: 'clearEmptyData',
                apiData: {
                    isAllData,
                    id: roleOrUserId,
                    licenseTypeId: licenseTypeIdData
                }
            }).then(res => {
                if (res.success) {
                    getRoleLicense();
                    antdMessage('success', '清除空数据成功');
                }
            });
    };

    /** 表头内容 */
    const columnsHead = [
        {
            title: '权限',
            dataIndex: "license",
            editable: true,
            render: (val: any) => (
                <Tooltip placement="topLeft" title={val?.memo}>
                    {val?.licenseName ?? '-'}
                </Tooltip>)
        },
        {
            title: '查看',
            dataIndex: 'isShow',
            editable: true,
            render: (text: any, record: any) => (
                <Switch checkedChildren="启用" unCheckedChildren="关闭"
                    checked={text} key={record.id}
                    onChange={(e) => handleChange(record.id, 'isShow', e)}
                />
            )
        },
        {
            title: '增加',
            dataIndex: 'isAdd',
            render: (text: any, record: any) => (
                <Switch checkedChildren="启用" unCheckedChildren="关闭"
                    checked={text} key={record.id}
                    onChange={(e) => handleChange(record.id, 'isAdd', e)}
                />
            )
        },
        {
            title: '更新',
            dataIndex: 'isUpdate',
            render: (text: any, record: any) => (
                <Switch checkedChildren="启用" unCheckedChildren="关闭"
                    checked={text} key={record.id}
                    onChange={(e) => handleChange(record.id, 'isUpdate', e)}
                />
            )
        },
        {
            title: '删除',
            dataIndex: 'isRemove',
            render: (text: any, record: any) => (
                <Switch checkedChildren="启用" unCheckedChildren="关闭"
                    checked={text} key={record.id}
                    onChange={(e) => handleChange(record.id, 'isRemove', e)}
                />
            )
        },
        {
            title: '下载',
            dataIndex: 'isDownload',
            render: (text: any, record: any) => (
                <Switch checkedChildren="启用" unCheckedChildren="关闭"
                    checked={text} key={record.id}
                    onChange={(e) => handleChange(record.id, 'isDownload', e)}
                />
            )
        },
        {
            title: '扩展',
            dataIndex: 'apiExtend',
            render: (text: any, record: any) =>
                <Space size="small">
                    <Button size={"small"} onClick={() => openExtend(record)}>扩展</Button>
                </Space>
        },
    ];

    /** 表头 */
    const columns = columnsheadId
        .concat(columnsHead as []);

    return (
        <>
            <AntDraggableModal
                title={title}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={handleOk}
                closable={false}
                maskClosable={false}
                width={1000} >
                <label>权限类型 :  </label>
                <Select
                    showSearch
                    defaultValue={defaultLicenseTypeId}
                    onChange={licenseTypeChange}
                    placeholder="权限类型"
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {getList.general(licenseTypeData)}
                </Select>
                <span> - </span>
                <label>权限组 :  </label>
                <Select
                    showSearch
                    defaultValue="所有权限组"
                    onChange={licenseGroupChange}
                    placeholder="权限组"
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {getList.general(licenseGroupData, 'licenseGroupName')}
                </Select>
                <span> - </span>
                <label>查询 :  </label>
                <Space>
                    <Input onKeyDown={(e: any) => {
                        if (e.key === 'Enter')
                            getRoleLicense({
                                licenseTypeId: licenseTypeIdData,
                                licenseGroupId: licenseGroupIdData,
                                current: currentData,
                                pageSize: pageSizeData,
                                queryString: queryData
                            })
                    }}
                        onChange={(e: any) => {
                            setQueryData(e.target.value)
                        }}
                    />
                </Space>

                <Tooltip placement="topLeft" title={'选择后会对所有数据的空数据清除'}>
                    <Checkbox onChange={(e) => {
                        setIsAllData(e.target.checked);
                    }} style={{ float: "right" }}>清空所有数据</Checkbox>
                </Tooltip>
                <span style={{ float: "right" }}>&nbsp;</span>
                <Popconfirm
                    title="是否清除空数据？"
                    description={`将会清除${isAllData === true ? '所有权限' : title}空数据！`}
                    trigger="click"
                    onConfirm={handleClearEmptyData}>
                    <Button style={{ float: "right", color: 'red' }}>清除空数据</Button>
                </Popconfirm >
                <span style={{ float: "right" }}>&nbsp;</span>
                <Button onClick={handleUpdate} style={{ float: "right" }}>更新数据</Button>

                <Table
                    rowKey={(row: any) => row.id}
                    columns={columns}
                    dataSource={rows}
                    size="small"
                    pagination={paginationProps}
                />
                {modalExtend ? (<RoleOrUserLicenseExtend
                    closeModal={onCloseModalExtend}
                    info={extendInfo}
                    useType={useType} />)
                    : null}
            </AntDraggableModal>
        </>
    )
}

export default RoleOrUserLicense;
